/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Clear_ButtonInputs */



/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Team_Share_Clear_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_clear_button = /** @type {((inputs?: Team_Share_Clear_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Clear_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Clear")
	if (locale === "de") return /** @type {LocalizedString} */ ("Clear")
	if (locale === "it") return /** @type {LocalizedString} */ ("Clear")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Clear")
	if (locale === "es") return /** @type {LocalizedString} */ ("Clear")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Clear")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Clear")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Clear")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Clear")
	return /** @type {LocalizedString} */ ("Clear")
});